module.exports = __webpack_public_path__ + "img/Marketing.76283bc3.png";